import axios from "axios";

import { IP } from "../utils/Host";


export function updateZmienCzasTrwaniaGrupyGantPrzerwa(drop_grupa_global_id,nowy_koniec,refreshGantAll) {

// id = procesor id

  axios.get(IP + "zmienCzasTrwaniaGrupyPrzerwa/"+drop_grupa_global_id+"/"+nowy_koniec)
    .then((res) => {

                  console.log("Oprawa przerwa Gant2")
      console.log("drop_grupa_global_id"+drop_grupa_global_id)
      console.log("nowy_koniec"+nowy_koniec)
    // console.log("procesor " +res.data[0].mcr)
    // fechparametryTechnologii
    refreshGantAll()

    });
}
